import { GridLoadResponse } from './load-grid-resource.model';

export enum LoadMasterPaidGridRequestKeys {
  loadOptions = 'loadOptions',
}

export interface LoadMasterPaidGridRequest {
  [LoadMasterPaidGridRequestKeys.loadOptions]?: Record<string, unknown>;
}

export type LoadMasterPaidGridResponse = GridLoadResponse;
